// Cliente da API de CONTATOS (leads capturados no site).
//
// Desde 2026-07-12 os contatos são servidos pela oplena_api (NestJS), a MESMA
// API do restante do admin (config.api.API_URL -> /admin/contatos). A rota
// aceita o Bearer JWT do login do admin — sem token extra assado no bundle.
// Resposta (sem envelope): { items, page, pageSize, total }.
import config from "../../../config";

const BASE = config.api.API_URL; // ex.: https://admin.oplena.com.br/api

const getToken = () => {
  try {
    return JSON.parse(localStorage.getItem("users") || "{}")?.token || "";
  } catch {
    return "";
  }
};

// Lista paginada de contatos. Retorna { items, page, pageSize, total }.
export const listContatos = async (page = 1, pageSize = 20) => {
  const url = `${BASE}/admin/contatos?page=${page}&pageSize=${pageSize}`;
  const res = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getToken()}`,
    },
  });
  let json = null;
  try {
    json = await res.json();
  } catch {
    json = null;
  }
  if (!res.ok) {
    throw new Error((json && json.message) || `Erro ${res.status}`);
  }
  return {
    items: (json && json.items) || [],
    page: (json && json.page) || page,
    pageSize: (json && json.pageSize) || pageSize,
    total: (json && json.total) || 0,
  };
};

export default { listContatos };
